import { IMAGES } from '@image/images';

export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const IMAGE_STORAGE_URL = import.meta.env.VITE_IMAGE_STORAGE_URL;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const LYFT_SOCKET = import.meta.env.VITE_LYFT_SOCKET;
export const TWILIO_BASE_URL = import.meta.env.VITE_TWILIO_BASE_URL;
export const VOICE_SOCKET_URL = import.meta.env.VITE_SOCKET_VOICE;
export const MASTER_KEY = import.meta.env.VITE_MASTER_KEY;

export const FALLBACK_IMAGE = IMAGES.defaultImage;

export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_KEY;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const APPLE_CLIENT_ID = import.meta.env.VITE_APPLE_CLIENT_ID;
export const DEFAULT_PAGE_SIZE = 5;
export const COVERAGE_AREA_TABLE_DEFAULT_PAGE_SIZE = 20;
export const BIG_TABLE_DEFAULT_PAGE_SIZE = 10;
export const SURVEY_TEMPLATE_DEFAULT_PAGE_SIZE = 50;
export const SURVEY_TABLE_SKELETON_DEFAULT_PAGE_SIZE = 50;
export const X_HEADER_ID_NAME = '3f7c9a2e-6b4d-4c1a-9e8f-2d5b7a1c0f3e';
export const CONTRACTOR_TIN_RESULT_STORAGE_KEY = 'ctr';

export const PASSWORD_TOKEN_PAGES = [
  '/authorization/reset-password',
  '/authorization/create-password',
];

export const AUTH_URLS = [
  '/authorization/forgot-password',
  '/authorization/check-email',
  '/authorization/get-verification-code',
  '/authorization/enter-verification-code',
  '/authorization/password-checked',
  '/authorization/expired-link',
  '/authorization/expired-link-sms',
  ...PASSWORD_TOKEN_PAGES,
];

export const LOGIN_PAGE_URL = '/authorization/login';
